import React from "react"

interface TabItem {
  id: string
  label: string
  icon?: {
    src: string
    alt?: string
  }
}

interface TableTabsProps {
  tabs: TabItem[]
  activeTab: string
  onTabChange: (tabId: string) => void
}

export function TableTabs({ tabs, activeTab, onTabChange }: TableTabsProps) {
  return (
    <div className="flex">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`relative flex items-center px-2 py-3 font-medium ${
            activeTab === tab.id ? "text-primary" : "text-gray-500 hover:text-gray-700"
          }`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon && <img src={tab.icon.src} alt={tab.icon.alt || ""} className="mr-2 h-4 w-4" />}
          {tab.label}
          {activeTab === tab.id && (
            <div className="absolute bottom-0 left-0 right-0 h-px bg-primary"></div>
          )}
        </button>
      ))}
    </div>
  )
}
